// takes a date string and returns milliseconds from now to exipration date
export const timeToExpire = (expiration: string) => {
  const expirationDate = new Date(expiration);
  const timeTillExpiration = expirationDate.getTime() - new Date().getTime();

  return timeTillExpiration;
};
